import PropTypes from 'prop-types';

import FloatingInput from '#/modules/commonComponents/form/FloatingInput';

/** 商業進貨表頭：關稅、運費。工單入庫不渲染。 */
const StockReceiptHeaderChargeFields = ({ register, errors }) => (
  <>
    <FloatingInput
      id="customsDutyAmount"
      type="number"
      label="關稅"
      register={register}
      errors={errors}
      min={0}
      step="0.01"
      placeholder="0"
    />
    <FloatingInput
      id="freightAmount"
      type="number"
      label="運費"
      register={register}
      errors={errors}
      min={0}
      step="0.01"
      placeholder="0"
    />
  </>
);

StockReceiptHeaderChargeFields.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

export default StockReceiptHeaderChargeFields;
